<template>
    <div class="">
        <div class="mb-8 border-b border-gray-325 last-of-type:mb-0">
            <div class="mx-4 font-[16px] text-gray-625">
                <div class="flex w-full flex-row items-end justify-between">
                    <div class="flex flex-col">
                        <div class="">
                            <div
                                class="flex items-center gap-2"
                                v-if="flashcardStack.type === 'emtprep'"
                            >
                                <div>
                                    <svg
                                        width="20"
                                        height="21"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M16.4045 13.1535C16.8867 12.8985 17.2903 12.5168 17.5718 12.0495C17.8533 11.5822 18.002 11.047 18.002 10.5015C18.002 9.95596 17.8533 9.42077 17.5718 8.95348C17.2903 8.4862 16.8867 8.10451 16.4045 7.84949C16.5652 7.32818 16.5808 6.77292 16.4495 6.24343C16.3182 5.71395 16.045 5.23029 15.6593 4.8445C15.2736 4.45871 14.79 4.18538 14.2605 4.05393C13.7311 3.92248 13.1758 3.93789 12.6545 4.09849C12.3995 3.61599 12.0178 3.21218 11.5504 2.93051C11.0831 2.64885 10.5477 2.5 10.002 2.5C9.45628 2.5 8.92092 2.64885 8.45353 2.93051C7.98613 3.21218 7.60442 3.61599 7.34949 4.09849C6.82818 3.93775 6.27292 3.9222 5.74343 4.0535C5.21395 4.18481 4.73029 4.45801 4.3445 4.8437C3.95871 5.22939 3.68538 5.71297 3.55393 6.24242C3.42248 6.77187 3.43789 7.32714 3.59849 7.84849C3.11599 8.10342 2.71218 8.48513 2.43051 8.95253C2.14885 9.41992 2 9.95528 2 10.501C2 11.0467 2.14885 11.5821 2.43051 12.0494C2.71218 12.5168 3.11599 12.8985 3.59849 13.1535C3.43775 13.6748 3.4222 14.2301 3.5535 14.7595C3.68481 15.289 3.95801 15.7727 4.3437 16.1585C4.72939 16.5443 5.21297 16.8176 5.74242 16.949C6.27187 17.0805 6.82714 17.0651 7.34849 16.9045C7.60342 17.387 7.98513 17.7908 8.45253 18.0725C8.91992 18.3541 9.45528 18.503 10.001 18.503C10.5467 18.503 11.0821 18.3541 11.5494 18.0725C12.0168 17.7908 12.3985 17.387 12.6535 16.9045C13.1748 17.0652 13.7301 17.0808 14.2595 16.9495C14.789 16.8182 15.2727 16.545 15.6585 16.1593C16.0443 15.7736 16.3176 15.29 16.449 14.7605C16.5805 14.2311 16.5651 13.6748 16.4045 13.1535ZM13.8585 8.69349C13.9165 8.61377 13.9582 8.52342 13.9812 8.42759C14.0043 8.33176 14.0083 8.23232 13.9929 8.13496C13.9775 8.0376 13.9431 7.94421 13.8917 7.86015C13.8402 7.77608 13.7727 7.70296 13.693 7.64499C13.6133 7.58701 13.5229 7.5453 13.4271 7.52224C13.3313 7.49918 13.2318 7.49522 13.1345 7.51058C13.0371 7.52595 12.9437 7.56035 12.8596 7.6118C12.7756 7.66326 12.7025 7.73077 12.6445 7.81049L9.16149 12.6005L7.28149 10.7205C7.21227 10.6489 7.12948 10.5918 7.03796 10.5525C6.94644 10.5133 6.84801 10.4926 6.74843 10.4918C6.64884 10.491 6.55009 10.51 6.45794 10.5478C6.36579 10.5855 6.28207 10.6412 6.21169 10.7117C6.1413 10.7821 6.08565 10.8659 6.04798 10.9581C6.01032 11.0503 5.99139 11.1491 5.9923 11.2486C5.99321 11.3482 6.01395 11.4466 6.0533 11.5381C6.09265 11.6296 6.14982 11.7123 6.22149 11.7815L8.72149 14.2815C8.79811 14.3582 8.89045 14.4173 8.99213 14.4549C9.09381 14.4924 9.20243 14.5075 9.3105 14.499C9.41856 14.4906 9.52351 14.4588 9.61811 14.4059C9.71272 14.3529 9.79472 14.2801 9.85849 14.1925L13.8585 8.69249V8.69349Z"
                                            fill="#1B90EE"
                                        />
                                    </svg>
                                </div>
                                <div>Official</div>
                                <div
                                    class="text-medium p-.5 rounded bg-primary-525 px-1 text-[14px] text-white"
                                    v-if="flashcardStack.is_new"
                                >
                                    New!
                                </div>
                            </div>
                            <div class="flex items-center gap-2" v-else>
                                <div>
                                    <svg
                                        width="16"
                                        height="19"
                                        viewBox="0 0 16 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M10.1791 0.829049C10.3011 0.896962 10.3969 1.00378 10.4511 1.13247C10.5053 1.26115 10.5149 1.40429 10.4783 1.53905L8.81829 7.62488H14.875C14.9968 7.62489 15.1159 7.66049 15.2177 7.7273C15.3196 7.79411 15.3997 7.88922 15.4482 8.00094C15.4967 8.11267 15.5115 8.23613 15.4908 8.35616C15.4701 8.47618 15.4148 8.58754 15.3316 8.67655L6.58163 18.0515C6.48632 18.1539 6.35946 18.2213 6.22132 18.243C6.08318 18.2647 5.94174 18.2395 5.81964 18.1713C5.69754 18.1032 5.60182 17.996 5.54779 17.8671C5.49376 17.7381 5.48455 17.5947 5.52163 17.4599L7.18163 11.3749H1.12496C1.00316 11.3749 0.884015 11.3393 0.782173 11.2725C0.680331 11.2057 0.60023 11.1105 0.551716 10.9988C0.503203 10.8871 0.488391 10.7636 0.509102 10.6436C0.529813 10.5236 0.585144 10.4122 0.668294 10.3232L9.41829 0.948215C9.5136 0.846254 9.64029 0.779126 9.77818 0.757529C9.91606 0.735932 10.0572 0.761109 10.1791 0.829049Z"
                                            fill="#FC8110"
                                        />
                                    </svg>
                                </div>
                                <div>Custom</div>
                            </div>
                        </div>
                        <div class="hover:cursor-pointer" @click="openStack">
                            <span
                                :class="
                                    'text-[16px] font-semibold' +
                                    ' ' +
                                    (flashcardStack.user_history.length
                                        ? 'text-purple-500'
                                        : 'text-primary-525')
                                "
                            >
                                <text-clamp
                                    autoResize
                                    :max-lines="1"
                                    :text="flashcardStack.title"
                                ></text-clamp> </span
                            ><span class="text-[14px]">
                                ({{
                                    flashcardStack.flashcards.length
                                }}
                                cards)</span
                            >
                        </div>
                    </div>
                    <div class="ml-4 flex items-center gap-2 text-[16px]">
                        <Link
                            :href="
                                route('student.flashcards.edit-stack', {
                                    flashcard_stack: flashcardStack.id,
                                })
                            "
                            v-if="flashcardStack.type === 'user'"
                            class="py-2 text-gray-625 hover:cursor-pointer hover:text-gray-700"
                        >
                            Edit
                        </Link>
                        <confirm-dialog
                            v-if="flashcardStack.type === 'user'"
                            size="2xl"
                            confirm-button-label="Delete"
                            confirm-button-css="rounded border bg-red-400 px-3 py-2 text-white hover:cursor-pointer hover:bg-red-300"
                            cancel-button-label="Cancel"
                            cancel-button-css="rounded border border-gray-700 px-3 py-2 text-gray-700 hover:cursor-pointer hover:bg-gray-325"
                            v-on:confirm="deleteStack"
                        >
                            <template #trigger>
                                <div
                                    class="mr-3 border-r border-gray-325 py-2 pr-3 text-red-400 hover:cursor-pointer hover:text-red-500"
                                >
                                    Delete
                                </div>
                            </template>
                            <template #content>
                                <div class="text-[16px] text-gray-700">
                                    Are you sure you want to delete this
                                    flashcard deck? All the flashcards contained
                                    inside will also be deleted.
                                </div>
                            </template>
                        </confirm-dialog>
                        <div
                            class="hidden text-gray-625 hover:cursor-pointer hover:text-gray-700 md:block"
                            @click="scrollBackward"
                        >
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g :opacity="canScrollBackward ? 1 : 0.5">
                                    <rect
                                        x="-0.6"
                                        y="0.6"
                                        width="30.8"
                                        height="30.8"
                                        rx="15.4"
                                        transform="matrix(-1 0 0 1 30.8 0)"
                                        fill="white"
                                    />
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M19.3478 10.2754C19.5132 10.4473 19.6036 10.6779 19.5991 10.9164C19.5946 11.1549 19.4956 11.3819 19.3238 11.5474L14.5982 15.9994L19.3238 20.4514C19.413 20.5324 19.4851 20.6304 19.5357 20.7397C19.5864 20.8489 19.6146 20.9673 19.6186 21.0877C19.6227 21.208 19.6026 21.328 19.5594 21.4405C19.5163 21.5529 19.451 21.6556 19.3674 21.7423C19.2839 21.8291 19.1838 21.8982 19.073 21.9456C18.9623 21.9929 18.8432 22.0176 18.7227 22.018C18.6023 22.0185 18.4829 21.9948 18.3718 21.9483C18.2607 21.9018 18.16 21.8335 18.0758 21.7474L12.6758 16.6474C12.5887 16.5635 12.5194 16.4628 12.4721 16.3515C12.4248 16.2401 12.4004 16.1204 12.4004 15.9994C12.4004 15.8785 12.4248 15.7587 12.4721 15.6474C12.5194 15.536 12.5887 15.4354 12.6758 15.3514L18.0758 10.2514C18.2477 10.086 18.4783 9.99566 18.7168 10.0002C18.9553 10.0047 19.1823 10.1037 19.3478 10.2754Z"
                                        fill="currentColor"
                                    />
                                    <rect
                                        x="-0.6"
                                        y="0.6"
                                        width="30.8"
                                        height="30.8"
                                        rx="15.4"
                                        transform="matrix(-1 0 0 1 30.8 0)"
                                        stroke="currentColor"
                                        stroke-width="1.2"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div
                            class="hidden text-gray-625 hover:cursor-pointer hover:text-gray-700 md:block"
                            @click="scrollForward"
                        >
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g :opacity="canScrollForward ? 1 : 0.5">
                                    <rect
                                        x="0.6"
                                        y="0.6"
                                        width="30.8"
                                        height="30.8"
                                        rx="15.4"
                                        fill="white"
                                    />
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12.6522 10.2754C12.4868 10.4473 12.3964 10.6779 12.4009 10.9164C12.4054 11.1549 12.5044 11.3819 12.6762 11.5474L17.4018 15.9994L12.6762 20.4514C12.587 20.5324 12.5149 20.6304 12.4643 20.7397C12.4136 20.8489 12.3854 20.9673 12.3814 21.0877C12.3773 21.208 12.3974 21.328 12.4406 21.4405C12.4837 21.5529 12.549 21.6556 12.6326 21.7423C12.7161 21.8291 12.8162 21.8982 12.927 21.9456C13.0377 21.9929 13.1568 22.0176 13.2773 22.018C13.3977 22.0185 13.5171 21.9948 13.6282 21.9483C13.7393 21.9018 13.84 21.8335 13.9242 21.7474L19.3242 16.6474C19.4113 16.5635 19.4806 16.4628 19.5279 16.3515C19.5752 16.2401 19.5996 16.1204 19.5996 15.9994C19.5996 15.8785 19.5752 15.7587 19.5279 15.6474C19.4806 15.536 19.4113 15.4354 19.3242 15.3514L13.9242 10.2514C13.7523 10.086 13.5217 9.99566 13.2832 10.0002C13.0447 10.0047 12.8177 10.1037 12.6522 10.2754Z"
                                        fill="currentColor"
                                    />
                                    <rect
                                        x="0.6"
                                        y="0.6"
                                        width="30.8"
                                        height="30.8"
                                        rx="15.4"
                                        stroke="currentColor"
                                        stroke-width="1.2"
                                    />
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div
                :ref="'flashcardRowContainer' + flashcardStack.id"
                class="my-4 ml-4 block flex-grow overflow-x-auto"
            >
                <div
                    class="flex w-[1px]"
                    :ref="'flashcardRow' + flashcardStack.id"
                >
                    <div
                        class="md:last-of-type:mr-4"
                        v-for="flashcard in flashcardStack.flashcards"
                    >
                        <div
                            class="mr-1 flex aspect-video h-24 flex-none items-center justify-center rounded border border-gray-325 p-4 text-center text-[14px] text-gray-625"
                        >
                            <text-clamp
                                autoResize
                                :max-lines="3"
                                :text="flashcard.front_content"
                            ></text-clamp>
                        </div>
                    </div>

                    <!--                    <carousel-->
                    <!--                        @page-change="handlePageChange"-->
                    <!--                        @mounted="handlePageChange"-->
                    <!--                        ref="flashcardCarousel"-->
                    <!--                        :loop="true"-->
                    <!--                        :per-page-custom="[-->
                    <!--                            [320, 2.5],-->
                    <!--                            [480, 3.5],-->
                    <!--                            [640, 5.5],-->
                    <!--                            [1199, 6.5],-->
                    <!--                        ]"-->
                    <!--                        :space-padding="0"-->
                    <!--                        :pagination-enabled="false"-->
                    <!--                        :navigation-enabled="false"-->
                    <!--                    >-->
                    <!--                        <slide-->
                    <!--                            class="md:last-of-type:mr-4"-->
                    <!--                            v-for="flashcard in flashcardStack.flashcards"-->
                    <!--                        >-->
                    <!--                            <div-->
                    <!--                                class="mr-1 flex aspect-video h-24 flex-none items-center justify-center rounded border border-gray-325 p-4 text-center text-[14px] text-gray-625"-->
                    <!--                            >-->
                    <!--                                <text-clamp-->
                    <!--                                    autoResize-->
                    <!--                                    :max-lines="3"-->
                    <!--                                    :text="flashcard.front_content"-->
                    <!--                                ></text-clamp>-->
                    <!--                            </div>-->
                    <!--                        </slide>-->
                    <!--                        <slide v-for="n in flashcardStack.flashcards.length % 4"-->
                    <!--                            >&nbsp;-->
                    <!--                        </slide>-->
                    <!--                    </carousel>-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Carousel, Slide } from "@jambonn/vue-concise-carousel";
import "@jambonn/vue-concise-carousel/lib/vue-concise-carousel.css";
import ConfirmDialog from "@/Components/ConfirmDialog.vue";

export default {
    name: "student-flashcard-stack-row",
    components: {
        ConfirmDialog,
        Carousel,
        Slide,
    },
    props: {
        flashcardStack: {},
    },
    data() {
        return {
            canScrollForward: true,
            canScrollBackward: false,
            pageCount: 0,
        };
    },
    methods: {
        openStack() {
            this.$inertia.get(
                route("student.flashcards.show-stack", {
                    flashcard_stack: this.flashcardStack.id,
                })
            );
        },
        scrollForward() {
            let vm = this;
            let scrollLeftTarget = 0;

            scrollLeftTarget =
                vm.$refs["flashcardRowContainer" + vm.flashcardStack.id]
                    .scrollLeft +
                vm.$refs["flashcardRowContainer" + vm.flashcardStack.id]
                    .clientWidth;

            vm.$refs["flashcardRowContainer" + vm.flashcardStack.id].scroll({
                top: 0,
                left: scrollLeftTarget,
                behavior: "smooth",
            });

            setTimeout(() => {
                vm.updateScrollButtons();
            }, 500);
        },
        scrollBackward() {
            let vm = this;
            let scrollRightTarget = 0;

            scrollRightTarget =
                vm.$refs["flashcardRowContainer" + vm.flashcardStack.id]
                    .scrollLeft -
                vm.$refs["flashcardRowContainer" + vm.flashcardStack.id]
                    .clientWidth;

            vm.$refs["flashcardRowContainer" + vm.flashcardStack.id].scroll({
                top: 0,
                left: scrollRightTarget,
                behavior: "smooth",
            });

            setTimeout(() => {
                vm.updateScrollButtons();
            }, 500);
        },
        updateScrollButtons() {
            this.canScrollForward =
                this.$refs["flashcardRowContainer" + this.flashcardStack.id]
                    .scrollLeft +
                    this.$refs["flashcardRowContainer" + this.flashcardStack.id]
                        .clientWidth <=
                this.$refs["flashcardRow" + this.flashcardStack.id]
                    .scrollWidth -
                    50;
            this.canScrollBackward =
                this.$refs["flashcardRowContainer" + this.flashcardStack.id]
                    .scrollLeft > 1;
        },
        deleteStack() {
            let vm = this;
            axios
                .post(
                    route("student.flashcards.delete-stack", {
                        flashcard_stack: vm.flashcardStack.id,
                    })
                )
                .then(function (response) {
                    window.location.reload();
                });
        },
    },
    mounted() {
        this.$refs["flashcardRowContainer" + this.flashcardStack.id].scroll({
            top: 0,
            left: 0,
            behavior: "instant",
        });

        setTimeout(() => {
            this.updateScrollButtons();
        }, 500);
    },
};
</script>
